// import cookie from '~/utils/cookie'

// 企业模块的store
export default {
  /**
   * 如果模块名称为：company
   *  state: { ... }, // this.$store.state.company.xxx
      getters: {
        isAdmin () { ... } // -> this.$store.getters['company/isAdmin']
      },
      actions: {
        login () { ... } // -> this.$store.dispatch('company/login')
      },
      mutations: {
        login () { ... } // -> this.$store.commit('company/login')
      }
   */
  // 开启命名空间
  namespaced: true,
  state: {
    // 外部的 返回对象
    backObj: localStorage.getItem('backObj') ? JSON.parse(localStorage.getItem('backObj')) : {
      // 返回路径
      path: '',
      // 返回标题
      title: ''
    }
  },
  mutations: {
    // 设置返回对象
    SET_BACK_OBJ (state, backObj) {
      localStorage.setItem('backObj', JSON.stringify(backObj))
      state.backObj = { ...backObj }
    }
  },
  actions: {

  },
  getters: {

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/outer.js